export default __webpack_public_path__ + "static/media/bitcoin-logo.2ff9f1d1.svg";